import MapPopupController from './map-popup/map-popup.controller';

const MapPopupTemplate = require('./map-popup/map-popup.html');

export default class ThingEditLocationController {
    /** @ngInject */
    constructor(DialogService, GeoService, EventEmitter) {
        this.DialogService = DialogService;
        this.GeoService = GeoService;
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.defaultCoordinates = this.GeoService.getCoordsByKey('default') || {};
    }

    showLocation(ev) {
        let marker;
        let centerCoordinates;

        if (this.location) {
            centerCoordinates = {
                lat: this.location.latitude,
                lng: this.location.longitude,
                address: this.location.address
            };

            marker = centerCoordinates;
        } else {
            centerCoordinates = {
                lat: this.defaultCoordinates.lat,
                lng: this.defaultCoordinates.lng
            };
        }

        this.DialogService.show({
            controller: MapPopupController,
            template: MapPopupTemplate,
            controllerAs: '$ctrl',
            parent: document.body,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                marker,
                centerCoordinates,
                updateMarker: this.updateMarker.bind(this),
                isEditing: true
            }
        });
    }

    updateMarker(marker) {
        let location = null;

        if (marker) {
            location = {
                address: marker.address,
                latitude: marker.lat,
                longitude: marker.lng
            };
        }

        this.onUpdate(
            this.eventEmitter({
                patch: {
                    location
                }
            })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-location/thing-location.controller.js